import config from '@bingads-webui-component-legacy/config/index';

export const initLegacyOdata = (serverContext) => {
  const hostname = document.location.hostname.toLowerCase();
  const isLocal = () => {
    // For sign up local environment, the hostname is ccui.devdev.bingads.microsoft.com
    if (hostname.indexOf('devdev') > -1) {
      return true;
    }
    return !/(^|\.)(bing)?ads(-int)?\.microsoft\.com$/.test(hostname);
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  config.set('odata.url', serverContext.ServicesEndpoints.CampaignAPI);
  config.set('odata.path', odataPath);
  config.set('odata.token', serverContext.Token);
};
